import React from 'react';

export default ({calculatePositionOfStickyHeaders, config, index}) => (
  <td
    className={`${index === 0 ? 'first-cell' : ''}`}
    style={calculatePositionOfStickyHeaders(config)}
  ></td>
);
